import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { BUGSNAG_API_KEY, STACK } from '../config';

let bugsnagClient: ReturnType<typeof Bugsnag.start> | null = null;

export function initBugsnag() {
  const apiKey = BUGSNAG_API_KEY;
  const disableBugsnag = import.meta.env.DEV;

  if (!apiKey || disableBugsnag) {
    return null;
  }

  if (bugsnagClient) {
    return bugsnagClient;
  }

  bugsnagClient = Bugsnag.start({
    apiKey,
    appVersion: __APP_VERSION__,
    releaseStage: STACK,
    plugins: [new BugsnagPluginReact()],
  });

  return bugsnagClient;
}

export function getBugsnagClient() {
  return bugsnagClient;
}
